"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_iris__scanner__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "394b7d26-094b-44d0-9a78-c1fac954923a",
    x1: 96,
    y1: 30.78,
    x2: 96,
    y2: 169.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), /*#__PURE__*/React.createElement("title", null, "iris-scanner-hi-dark"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2e36ed0-9b2c-47fa-86ca-b7f60b04edfd",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,56a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4H52a4,4,0,0,1,0,8H32V52A4,4,0,0,1,28,56Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,53.67a4,4,0,0,1-4-4V52a4,4,0,0,0,8,0V49.67A4,4,0,0,1,28,53.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29.67H32V32H52a4,4,0,0,0,4-4,4.09,4.09,0,0,0-.19-1.17A4,4,0,0,1,52,29.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52,168H28a4,4,0,0,1-4-4V140a4,4,0,0,1,8,0v20H52a4,4,0,0,1,0,8Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,165.83H28a4,4,0,0,1-4-4V164a4,4,0,0,0,4,4H52a4,4,0,0,0,4-4,3.81,3.81,0,0,0-.17-1.08A4,4,0,0,1,52,165.83Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,56a4,4,0,0,1-4-4V32H140a4,4,0,0,1,0-8h24a4,4,0,0,1,4,4V52A4,4,0,0,1,164,56Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,53.67a4,4,0,0,0,4-4V52a4,4,0,0,1-8,0V49.67A4,4,0,0,0,164,53.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,29.67h20V32H140a4,4,0,0,1-4-4,4.09,4.09,0,0,1,.19-1.17A4,4,0,0,0,140,29.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164,168H140a4,4,0,0,1,0-8h20V140a4,4,0,0,1,8,0v24A4,4,0,0,1,164,168Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,165.83h24a4,4,0,0,0,4-4V164a4,4,0,0,1-4,4H140a4,4,0,0,1-4-4,3.81,3.81,0,0,1,.17-1.08A4,4,0,0,0,140,165.83Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "d05f2901-6acc-41da-b22e-e9caf8c9f59e",
    "data-name": "9b7af19c-57c6-4b30-83f2-a0593da92088",
    d: "M96,140c-46.07,0-66.91-42.95-67.7-44.93a5.49,5.49,0,0,1,0-3.58c.79-1.6,21.63-44.55,67.7-44.55s66.91,43,67.7,44.93a5.49,5.49,0,0,1,0,3.58C162.91,97.05,142.07,140,96,140Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,60.78c39,0,59.91,20.48,65.9,27.57C155.9,77.69,135,46.94,96,46.94c-39.29,0-60.22,31.22-66,41.41C35.77,81.58,56.69,60.78,96,60.78Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "9226c389-a7c5-494a-bf26-ff839816c982",
    "data-name": "85cdf7db-2a26-416b-a1ca-d38b97548ce9",
    d: "M96,64.58a30.62,30.62,0,1,1-.26,0Z",
    fill: "url(#394b7d26-094b-44d0-9a78-c1fac954923a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 95.33,
    r: 11.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,105.81a12,12,0,0,1-12-11.23c0,.24,0,.49,0,.75a12,12,0,0,0,24,0c0-.26,0-.51,0-.75A12,12,0,0,1,96,105.81Z",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.91,138c-33,0-53.36-21.12-62.85-34.43C41.67,116.63,61.92,140,95.91,140c34.24,0,54.53-23.72,63-36.56C149.54,116.59,129.15,138,95.91,138Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_iris__scanner__dark;
exports.default = _default;